(async () => {
  trfBcConfig.tabletBreakpoint = 768;
  const filterUrl = new URL('https://services.mybcapps.com/bc-sf-filter/filter');
  const boostSDAppConfig = window.boostSDAppConfig || {};
  const defaultSettings = {
    mode: 'production',
    api: {
      filterUrl: 'https://staging.bc-solutions.net/bc-sf-filter/filter',
      searchUrl: 'https://staging.bc-solutions.net/bc-sf-filter/search',
      recommendUrl: 'https://staging.bc-solutions.net/discovery/recommend',
      suggestionUrl: 'https://staging.bc-solutions.net/bc-sf-filter/search/suggest',
      productsUrl: 'https://staging.bc-solutions.net/bc-sf-filter/search/products',
      cdn: 'https://boost-cdn-staging.bc-solutions.net',
    },
    shop: {
      name: 'Hunt Bike Wheels',
      url: 'https://www.huntbikewheels.com',
      domain: 'huntbikewheels.myshopify.com',
      currency: 'GBP',
      money_format: '<span class="money">£{{ amount }}</span>',
      money_format_with_currency: '<span class="money">£{{ amount }} GBP</span>',
    },
    filterSettings: Object.assign(
      {
        swatch_extension: 'png',
      },
      {
        showFilterOptionCount: true,
        showRefineBy: true,
        showOutOfStockOption: false,
        showSingleOption: false,
        keepToggleState: true,
        changeMobileButtonLabel: false,
        sortingAvailableFirst: false,
        showLoading: false,
        activeScrollToTop: false,
        showVariantImageBasedOnSelectedFilter: '',
        productAndVariantAvailable: false,
        availableAfterFiltering: false,
        isShortenUrlParam: false,
        style: {
          filterTitleTextColor: '',
          filterTitleFontSize: '',
          filterTitleFontWeight: '',
          filterTitleFontTransform: '',
          filterTitleFontFamily: '',
          filterOptionTextColor: '',
          filterOptionFontSize: '',
          filterOptionFontFamily: '',
          filterMobileButtonTextColor: '',
          filterMobileButtonFontSize: '',
          filterMobileButtonFontWeight: '',
          filterMobileButtonFontTransform: '',
          filterMobileButtonFontFamily: '',
          filterMobileButtonBackgroundColor: '',
        },
      }
    ),

    searchSettings: {
      searchPanelBlocks: {
        products: {
          label: 'Products',
          pageSize: 25,
          active: true,
          displayImage: true,
        },
        collections: {
          label: 'Collections',
          pageSize: 25,
          active: false,
          displayImage: false,
        },
        pages: {
          label: 'Pages',
          pageSize: 25,
          active: false,
          displayImage: false,
        },
        searchTermSuggestions: {
          label: 'Popular searches',
          type: 'manually',
          active: false,
          backup: [],
          searchTermList: [],
        },
        mostPopularProducts: {
          label: 'Trending products',
          type: 'manually',
          active: false,
          backup: [],
          productList: [],
        },
      },
      suggestionNoResult: {
        search_terms: {
          label: 'Popular searches',
          status: false,
          data: [],
          backup: [],
          type: 'manually',
        },
        products: {
          label: 'Trending products',
          status: false,
          data: [],
          backup: [],
          type: 'manually',
        },
      },
      enableInstantSearch: true,
      productAvailable: false,
      showSuggestionProductImage: true,
      showSuggestionProductPrice: true,
      showSuggestionProductSalePrice: true,
      showSuggestionProductSku: false,
      showSuggestionProductVendor: false,
      suggestionBlocks: [
        {
          type: 'suggestions',
          label: 'Popular suggestions',
          status: 'active',
          number: 5,
        },
        {
          type: 'collections',
          label: 'Collections',
          status: 'disabled',
          number: 3,
        },
        {
          type: 'products',
          label: 'Products',
          status: 'active',
          number: 3,
        },
        {
          type: 'pages',
          label: 'Pages',
          status: 'active',
          number: 3,
        },
      ],
      searchBoxOnclick: {
        recentSearch: {
          label: 'Recent searches',
          status: true,
          number: '3',
        },
        searchTermSuggestion: {
          label: 'Popular searches',
          status: false,
          data: [],
        },
        productSuggestion: {
          label: 'Trending products',
          status: false,
          data: [],
        },
      },
    },

    additionalElementSettings: Object.assign(
      {},
      {
        customSortingList: 'relevance|best-selling|manual|price-ascending|price-descending',
      }
    ),
    generalSettings: Object.assign(
      {
        preview_mode: false,
        preview_path: '',
        page: 'collection',
        file_url: '//www.huntbikewheels.com/cdn/shop/files/?21441',
        custom_js_asset_url: '',
        custom_css_asset_url: '',
        collection_id: 137115205709,
        collection_handle: 'road-cx-disc-brake-wheels',
        collection_product_count: 22,

        collection_count: 22,

        collection_tags: null,
        current_tags: null,
        default_sort_by: 'manual',
        swatch_extension: 'png',
        no_image_url:
          'https://cdn.shopify.com/extensions/b8fb1e92-1951-4ffe-9a65-3256dd228a48/boost-ai-search-discovery-76/assets/boost-pfs-no-image.jpg',
        search_term: '',
        template: 'collection',
        currencies: ['GBP'],
        current_currency: 'GBP',
        published_locales: {
          en: true,
        },
        current_locale: 'en',
      },
      {
        enableTrackingOrderRevenue: true,
        addCollectionToProductUrl: true,
      }
    ),
    themeSettings: {},
    themeInfo: null,

    translation: {
      search: {
        searchPanelProduct: 'Products',
        searchPanelCollection: 'Collections',
        searchPanelPage: 'Pages',
        noSearchResultSearchTermLabel: 'Popular searches',
        noSearchResultProductsLabel: 'Trending products',
        searchBoxOnclickRecentSearchLabel: 'Recent searches',
        searchBoxOnclickSearchTermLabel: 'Popular searches',
        searchBoxOnclickProductsLabel: 'Trending products',
      },
      suggestion: {
        instantSearchSuggestionsLabel: 'Popular suggestions',
        instantSearchCollectionsLabel: 'Collections',
        instantSearchProductsLabel: 'Products',
        instantSearchPagesLabel: 'Pages',
        searchBoxOnclickRecentSearchLabel: 'Recent searches',
        searchBoxOnclickSearchTermLabel: 'Popular searches',
        searchBoxOnclickProductsLabel: 'Trending products',
        noSearchResultSearchTermLabel: 'Popular searches',
        noSearchResultProductsLabel: 'Trending products',
      },
      error: {},
      recommendation: {
        'homepage-473182': 'Just dropped',
        'homepage-773865': 'Best Sellers',
        'collectionpage-135535': 'Just dropped',
        'collectionpage-540181': 'Most Popular Products',
        'productpage-308872': 'Recently viewed',
        'productpage-058623': 'Frequently Bought Together',
        'cartpage-471280': 'Still interested in this?',
        'cartpage-786027': 'Similar Products',
      },
      productItem: {
        qvBtnLabel: null,
        atcAvailableLabel: null,
        soldoutLabel: null,
        productItemSale: 'SALE',
        productItemSoldOut: 'SOLD OUT',
        viewProductBtnLabel: 'Buy',
        atcSelectOptionsLabel: null,
        amount: '',
        savingAmount: 'Save {{saleAmount}}',
        swatchButtonText1: null,
        swatchButtonText2: null,
        swatchButtonText3: null,
        inventoryInStock: null,
        inventoryLowStock: null,
        inventorySoldOut: null,
        atcAddingToCartBtnLabel: null,
        atcAddedToCartBtnLabel: null,
      },
      quickView: {
        buyItNowBtnLabel: 'Buy it now',
      },
      cart: {
        atcMiniCartViewCartLabel: 'View cart',
        atcMiniCartCheckoutLabel: 'Checkout',
      },
      recentlyViewed: {},
      mostPopular: {},
      perpage: {},
      productCount: {
        textDescriptionCollectionHeader: null,
        textDescriptionCollectionHeaderPlural: null,
        textDescriptionToolbar: '{{count}} products',
        textDescriptionToolbarPlural: '{{count}} products',
        textDescriptionPagination: 'Showing {{from}} - {{to}} of {{total}} products',
        textDescriptionPaginationPlural: 'Showing {{from}} - {{to}} of {{total}} products',
      },
      pagination: {
        loadMoreText: 'Load more',
        prevText: 'Previous',
        nextText: 'Next',
      },
      sortingList: {
        relevance: 'Relevance',
        'best-selling': 'Best selling',
        manual: 'Manual',
        'price-ascending': 'Price ascending',
        'price-descending': 'Price descending',
      },
      collectionHeader: {},
      breadcrumb: {},
      sliderProduct: {},
    },

    primary_language: {
      search: {
        searchPanelProduct: 'Products',
        searchPanelCollection: 'Collections',
        searchPanelPage: 'Pages',
        noSearchResultSearchTermLabel: 'Popular searches',
        noSearchResultProductsLabel: 'Trending products',
        searchBoxOnclickRecentSearchLabel: 'Recent searches',
        searchBoxOnclickSearchTermLabel: 'Popular searches',
        searchBoxOnclickProductsLabel: 'Trending products',
      },
      suggestion: {
        instantSearchSuggestionsLabel: 'Popular suggestions',
        instantSearchCollectionsLabel: 'Collections',
        instantSearchProductsLabel: 'Products',
        instantSearchPagesLabel: 'Pages',
        searchBoxOnclickRecentSearchLabel: 'Recent searches',
        searchBoxOnclickSearchTermLabel: 'Popular searches',
        searchBoxOnclickProductsLabel: 'Trending products',
        noSearchResultSearchTermLabel: 'Popular searches',
        noSearchResultProductsLabel: 'Trending products',
      },
      error: {},
      recommendation: {
        'homepage-473182': 'Just dropped',
        'homepage-773865': 'Best Sellers',
        'collectionpage-135535': 'Just dropped',
        'collectionpage-540181': 'Most Popular Products',
        'productpage-308872': 'Recently viewed',
        'productpage-058623': 'Frequently Bought Together',
        'cartpage-471280': 'Still interested in this?',
        'cartpage-786027': 'Similar Products',
      },
      productItem: {
        qvBtnLabel: null,
        atcAvailableLabel: null,
        soldoutLabel: null,
        productItemSale: 'SALE',
        productItemSoldOut: 'SOLD OUT',
        viewProductBtnLabel: 'Buy',
        atcSelectOptionsLabel: null,
        amount: '',
        savingAmount: 'Save {{saleAmount}}',
        swatchButtonText1: null,
        swatchButtonText2: null,
        swatchButtonText3: null,
        inventoryInStock: null,
        inventoryLowStock: null,
        inventorySoldOut: null,
        atcAddingToCartBtnLabel: null,
        atcAddedToCartBtnLabel: null,
      },
      quickView: {
        buyItNowBtnLabel: 'Buy it now',
      },
      cart: {
        atcMiniCartViewCartLabel: 'View cart',
        atcMiniCartCheckoutLabel: 'Checkout',
      },
      recentlyViewed: {},
      mostPopular: {},
      perpage: {},
      productCount: {
        textDescriptionCollectionHeader: null,
        textDescriptionCollectionHeaderPlural: null,
        textDescriptionToolbar: '{{count}} products',
        textDescriptionToolbarPlural: '{{count}} products',
        textDescriptionPagination: 'Showing {{from}} - {{to}} of {{total}} products',
        textDescriptionPaginationPlural: 'Showing {{from}} - {{to}} of {{total}} products',
      },
      pagination: {
        loadMoreText: 'Load more',
        prevText: 'Previous',
        nextText: 'Next',
      },
      sortingList: {
        relevance: 'Relevance',
        'best-selling': 'Best selling',
        manual: 'Manual',
        'price-ascending': 'Price ascending',
        'price-descending': 'Price descending',
      },
      collectionHeader: {},
      breadcrumb: {},
      sliderProduct: {},
    },

    versioning: {
      invalidateCache: {
        invalidParams: `?v=${Date.now()}`,
        latestTime: 1690942680852,
      },
    },
  };

  const finalSettings = $.extend(true, defaultSettings, boostSDAppConfig);

  filterUrl.search = new URLSearchParams({
    _: 'pf',
    shop: trfBcConfig.shopUrl,
    event_type: 'filter',
    build_filter_tree: true,
    zero_options: finalSettings.filterSettings.showOutOfStockOption,
    product_available: false,
    variant_available: false,
    limit: 70,
    collection_scope: trfBcConfig.collectionId,
    collectionId: trfBcConfig.collectionId,
    handle: trfBcConfig.collectionHandle,
  });
  const filterWrapper = document.querySelector('#trf-filter-tree-wrapper');
  const filterGroupTemplate = document.querySelector('#trf-filter-option-group');

  let areFiltersApplied = false;

  const filterOptionMultiselectTemplate = document.querySelector('#trf-filter-option-multiselect');
  const filterOptionSingleselectTemplate = document.querySelector('#trf-filter-option-singleselect');
  const filterRangeTemplate = document.querySelector('#trf-filter-range');
  const sortOptionsAnchors = document.querySelectorAll('.trf-sort-by-option');
  const sortOptionCheckboxes = document.querySelectorAll('.trf-sort-by-option .trf-sort-option-checkbox');

  // TODO implement applied filter items on top of filter tree
  // const appliedFiltersWrapper = document.querySelector('.filter-group--applied');
  // const appliedFilterTemplate = document.querySelector('#trf-applied-filter-template');
  // const appliedFilters = document.querySelector('.filter-group__applied-items');
  // const clearBtn = document.querySelector('.trf-clear-link');

  if (!filterWrapper) return;
  if (!filterGroupTemplate) return;
  if (!filterOptionMultiselectTemplate) return;
  if (!filterRangeTemplate) return;
  if (!sortOptionsAnchors) return;
  if (!sortOptionCheckboxes) return;
  // if (!appliedFilterTemplate) return;

  const getFiltersResponse = async (additionalParams) => {
    const url = new URL(filterUrl);
    const currentParams = new URLSearchParams(window.location.search);
    const newParams = new URLSearchParams(url.search);

    currentParams.forEach((value, key) => {
      newParams.append(key + '[]', value);
    });

    if (!!additionalParams) {
      for (const [key, value] of Object.entries(additionalParams)) {
        if (!newParams.keys().includes(key)) {
          newParams.append(key, value);
        }
      }
    }
    url.search = newParams;

    const response = await fetch(url)
      .then(
        (result) => result.json(),
        (err) => {
          console.log(err);
        }
      )
      .then((res) => res);

    if (!response.filter && !response.filter.options) {
      return;
    }
    return response;
  };

  const buildListOption = (option, wrapper) => {
    option.values.forEach((value, innerIdx) => {
      const optionClone =
        option.selectType === 'multiple'
          ? filterOptionMultiselectTemplate.content.cloneNode(true)
          : filterOptionSingleselectTemplate.content.cloneNode(true);
      const optionInput = optionClone.querySelector('.filter-group__checkbox');
      optionInput.name = option.filterOptionId;
      optionInput.value = value.key;
      optionClone.querySelector('.filter-group__item').id = `filter-item--${option.filterOptionId}-${innerIdx}`;
      optionClone.querySelector('.filter-group__item__text').innerText = value.key;
      optionClone.querySelector('.filter-group__item__count').innerText = value.doc_count;
      wrapper.appendChild(optionClone);
    });
  };

  const buildRangeOption = (option, wrapper) => {
    const rangeClone = filterRangeTemplate.content.cloneNode(true);
    const inputMin = rangeClone.querySelector('.cc-price-range__input--min');
    const inputMax = rangeClone.querySelector('.cc-price-range__input--max');
    const barControlMin = rangeClone.querySelector('.cc-price-range__control--min');
    const barControlMax = rangeClone.querySelector('.cc-price-range__control--max');

    inputMin.setAttribute('placeholder', option.values.min);
    inputMax.setAttribute('placeholder', option.values.max);

    inputMin.setAttribute('max', option.values.max);
    inputMax.setAttribute('max', option.values.max);

    barControlMin.setAttribute('aria-valuemax', option.values.max);
    barControlMax.setAttribute('aria-valuemax', option.values.max);
    barControlMax.setAttribute('aria-valuenow', option.values.max);

    wrapper.append(rangeClone);
  };

  const getFilterGroupCollapsedState = (filterWrapper) => {
    // Stores the state whether group box is collapsed or not: `{ <unique-group-body-class-with-id>: <is-collapsed> }`
    const filterGroupCollapsedState = {};
    const elsFilterGroupBodies = filterWrapper.querySelectorAll(`.filter-group__items`);

    for (const elFilterGroupBody of elsFilterGroupBodies) {
      const filterGroupBodyIdxClassName = Array.from(elFilterGroupBody.classList)
        // get the unique group body class with ID from the page
        .find((className) => className.startsWith('trf-filter-group-body-'));

      // we assume that the presence of the `toggle-target--hidden` class defines whether the filter group is collapsed or not.
      filterGroupCollapsedState[filterGroupBodyIdxClassName] =
        elFilterGroupBody.classList.contains('toggle-target--hidden');
    }
    return filterGroupCollapsedState;
  };

  const buildFilterTree = (filterOptions, filterGroupCollapsedState = {}) => {
    if (!Array.isArray(filterOptions)) return;

    filterOptions.forEach((option, idx) => {
      if (option.status === 'disabled') return;
      const clone = filterGroupTemplate.content.cloneNode(true);
      const currentParams = new URLSearchParams(window.location.search);

      for (const key of currentParams.keys()) {
        if (key.includes(option.filterOptionId)) {
          areFiltersApplied = true;
          break;
        }
      }

      clone.querySelector('.filter-group__heading__text').innerText = option.label;

      if (option.filterOptionId === 'pf_t_ic_number') {
        clone.querySelector('.filter-group').classList.add('hidden');
      }

      const cloneOptionsWrapper = clone.querySelector('.toggle-target-container');

      const elFilterGroupHead = clone.querySelector('.filter-group__heading');
      const elFilterGroupBody = clone.querySelector('.filter-group__items');
      const filterGroupBodyIdxClassName = `trf-filter-group-body-${idx}`;

      elFilterGroupHead.dataset.toggleTarget = `.${filterGroupBodyIdxClassName}`;
      elFilterGroupBody.classList.add(filterGroupBodyIdxClassName);

      // if we already have the collapse state of the filter group from previous user interaction, use it
      if (filterGroupBodyIdxClassName in filterGroupCollapsedState) {
        if (filterGroupCollapsedState[filterGroupBodyIdxClassName]) {
          elFilterGroupBody.classList.add('toggle-target--hidden');
        }
        // otherwise compute the collapse state from filter app settings
        // TODO this is not working if you resize your screen (e.g. rotate your phone)
      } else {
        if (
          (option.isCollapsePC && window.innerWidth > trfBcConfig.tabletBreakpoint) ||
          (option.isCollapseMobile && window.innerWidth <= trfBcConfig.tabletBreakpoint)
        ) {
          elFilterGroupBody.classList.add('toggle-target--hidden');
        }
      }

      if (option.displayType === 'list') {
        buildListOption(option, cloneOptionsWrapper);
        filterWrapper.append(clone);
      }
      if (option.displayType === 'range') {
        if (!option.values || !option.values.min || !option.values.max) return;
        buildRangeOption(option, cloneOptionsWrapper);
        filterWrapper.append(clone);
      }

      currentParams.forEach((paramValue, param) => {
        const input = filterWrapper.querySelector(`[name='${CSS.escape(param)}'][value='${CSS.escape(paramValue)}']`);
        if (input) input.checked = true;
      });
    });

    const filterInputs = filterWrapper.querySelectorAll('input');
    filterInputs.forEach((input) => {
      if (input.type === 'radio') {
        input.addEventListener('click', (event) => {
          const currentParams = new URLSearchParams(window.location.search);
          if (Array.from(currentParams.values()).includes(input.value)) {
            input.checked = false;
            input.dispatchEvent(new Event('change'));
          }
        });
      }
      input.addEventListener('change', async (event) => {
        await applyFilters(filterInputs);
      });
    });
  };

  const updateFilterCount = (filterOptions) => {
    const filterGroupCollapsedState = getFilterGroupCollapsedState(filterWrapper);

    filterWrapper.innerHTML = '';
    buildFilterTree(filterOptions, filterGroupCollapsedState);
  };

  const resetProductList = () => {
    // appliedFiltersWrapper.hidden = true;
    document
      .querySelectorAll('.product-block:not(.trf-rider-favourite):not(.trf-content-block-wrapper)')
      .forEach((productCard) => {
        productCard.style.display = 'block';
      });
    document.querySelector('.collection-listing').classList.remove('trf-filtered');
  };

  const updateSortUrls = () => {
    const currentFilterParams = new URLSearchParams(window.location.search);
    sortOptionsAnchors.forEach((sortOptionAnchor) => {
      const url = new URL(sortOptionAnchor.href);
      const urlParams = new URLSearchParams(url.search);
      // delete all filter params
      Array.from(urlParams.keys())
        .filter((key) => key.startsWith('pf_'))
        .forEach((key) => {
          urlParams.delete(key);
        });
      // re-add filter params
      Array.from(currentFilterParams.entries()).forEach(([key, value]) => {
        urlParams.append(key, value);
      });
      url.search = urlParams;
      sortOptionAnchor.href = url;
    });
  };

  const renderFilteredProducts = (productIds, areFiltersApplied) => {
    if (!areFiltersApplied) return;
    if (!Array.isArray(productIds)) return;

    document.querySelector('.collection-listing').classList.add('trf-filtered');
    document
      .querySelectorAll('.product-block:not(.trf-rider-favourite):not(.trf-content-block-wrapper)')
      .forEach((productCard) => {
        if (!productIds.includes(productCard.dataset.productId)) productCard.style.display = 'none';
      });
  };

  // clearBtn.addEventListener('click', (event) => {
  //   event.preventDefault();
  //   if (history.pushState) {
  //     const newUrl = new URL(window.location.href);
  //     newUrl.search = '';
  //     history.pushState({ path: newUrl.toString() }, '', newUrl.toString());
  //   }
  //   resetProductList();
  //   areFiltersApplied = false;
  //   filterWrapper.querySelectorAll('[type='checkbox']').forEach(input => {
  //     input.checked = false;
  //   });
  //   appliedFilters.innerHTML = '';
  // });

  const filterResponse = await getFiltersResponse();
  buildFilterTree(filterResponse.filter.options, {});

  const productIds = filterResponse.products.map((product) => String(product.id));

  const applyFilters = async (filterInputs) => {
    document.body.classList.add('ajax-loading');
    const currentParams = new URLSearchParams();
    areFiltersApplied = false;
    filterInputs.forEach((input) => {
      if (input.checked) {
        areFiltersApplied = true;
        currentParams.append(input.name, input.value);
      }
    });
    if (history.pushState) {
      const newUrl = new URL(window.location.href);
      newUrl.search = currentParams;
      history.pushState({ path: newUrl.toString() }, '', newUrl.toString());
    }
    const response = await getFiltersResponse();
    const productIds = response.products.map((product) => String(product.id));
    resetProductList();
    renderFilteredProducts(productIds, areFiltersApplied);

    updateFilterCount(response.filter.options);
    updateSortUrls();
    // appliedFiltersWrapper.hidden = !areFiltersApplied;
    document.dispatchEvent(new Event('trf-filter-applied'));

    document.body.classList.remove('ajax-loading');
  };

  renderFilteredProducts(productIds, areFiltersApplied);

  updateFilterCount(filterResponse.filter.options);

  sortOptionsAnchors.forEach((sortOption) => {
    sortOption.addEventListener('click', (event) => {
      sortOptionCheckboxes.forEach((input) => {
        input.checked = false;
      });
      sortOption.querySelector('.filter-group__checkbox').checked = true;
    });
  });

  const elCollectionsContainer = document.querySelector('[data-section-type="collection-template"]');
  const collectionInstance = theme.Sections._instances.find((i) => i.target === elCollectionsContainer);

  const oldInitFiltersEtc = collectionInstance.thisContext.filterer.functions.initFiltersEtc;

  collectionInstance.thisContext.filterer.functions.initFiltersEtc = function () {
    oldInitFiltersEtc.call(this);

    const filterInputs = filterWrapper.querySelectorAll('input');
    applyFilters(filterInputs).catch((error) => {
      console.error('Cannot apply filters');
      console.error(error);
    });
  };
})();
